import { apiList } from '../api/apiList'
import axiosInstance from '../api/axiosInstance'
import axiosInstance2 from '../api/axiosInstance2'

const endpoint = apiList.settingApi

const settingService = {
  update: (companyId, payload) => axiosInstance.put(`${endpoint}/${companyId}`, payload),
  get: (companyId) => axiosInstance.get(`${endpoint}/${companyId}`),
  getLeagues : () => axiosInstance2.get(apiList.getLeaguesApi),
}

export default settingService